import { Box, Flex, Select } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { FormField, MultiSelect } from 'shared/components';
import { JobCategoryGroupModel } from './job-category-group.model';
import { JobCategory } from 'jobs/types';
import { ReactNode } from 'react';

const JobCategoryGroupView = ({
   model,
   required = false,
   categoryError = '',
   subCategoryError = '',
   actions,
   categories,
}: {
   model: JobCategoryGroupModel;
   required?: boolean;
   categoryError?: string;
   subCategoryError?: string;
   actions: ReactNode;
   categories: JobCategory[];
}) => {
   if (model.hidden) {
      return null;
   }
   return (
      <Box className="category-control" pr={required ? '0' : '100px'}>
         <Flex direction="column" align="baseline" justify="between" gap="3">
            <Flex
               className="categories-action"
               width="100%"
               align={categoryError ? 'center' : 'end'}
               gap="4"
            >
               <FormField label="Категорія" required={required} error={categoryError}>
                  <Select.Root
                     size="3"
                     value={model.category}
                     onValueChange={(cat) => {
                        model.onCategoryChange(cat)
                        model.multiselect.clear();
                     }}
                  >
                     <Select.Trigger placeholder="Виберіть категорію роботи"></Select.Trigger>
                     <Select.Content
                        color="blue"
                        position="popper"
                        onCloseAutoFocus={(e) => e.preventDefault()}
                     >
                        <Box maxHeight="250px">
                           {categories.map((cat) => {
                              return (
                                 <Select.Item key={cat.id} value={cat.id.toString()}>
                                    {cat.name}
                                 </Select.Item>
                              );
                           })}
                        </Box>
                     </Select.Content>
                  </Select.Root>
               </FormField>

               {actions}
            </Flex>

            <FormField label="Спеціалізація" required={required} error={subCategoryError}>
               <MultiSelect.Root
                  vm={model.multiselect}
                  placeholder="Виберіть спеціалізацію"
               >
                  {model.results.map((subCat) => {
                     return (
                        <MultiSelect.Option<JobCategory> key={subCat.id} value={subCat}>
                           {subCat.name}
                        </MultiSelect.Option>
                     );
                  })}
               </MultiSelect.Root>
            </FormField>
         </Flex>
      </Box>
   );
};

export const JobCategoryGroup = observer(JobCategoryGroupView);
